export default {
  set: (context, payload) => {
    context.commit('set', payload);
  },
}
